module.exports = __webpack_public_path__ + "character1.8b98436a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/character1.png
// module id = tiYY
// module chunks = 0